import { render } from "./suppliesTable.vue?vue&type=template&id=c8ef70a6&scoped=true&ts=true&lang=pug"
import script from "./suppliesTable.vue?vue&type=script&lang=ts"
export * from "./suppliesTable.vue?vue&type=script&lang=ts"

import "./suppliesTable.vue?vue&type=style&index=0&id=c8ef70a6&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8ef70a6"]])

export default __exports__